import { doc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from './firebase';

// Default preferences — service comms ON, marketing OFF (Australian Spam Act)
export const DEFAULT_PREFS = {
  bookingConfirmations: { email: true, sms: true },
  paymentReminders: { email: true, sms: true },
  doorAccess: { email: true, sms: true },
  marketing: { email: false },
};

export const PREF_LABELS = {
  bookingConfirmations: { label: 'Booking Confirmations', description: 'Confirmation when you book or cancel a space', type: 'service' },
  paymentReminders: { label: 'Payment & Invoices', description: 'Payment links, reminders, and refund notifications', type: 'service' },
  doorAccess: { label: 'Door Access PINs', description: 'Your door PIN code before a booking', type: 'service' },
  marketing: { label: 'News & Updates', description: 'Hub news, events, and promotions', type: 'marketing' },
};

export const getNotificationPrefs = async (uid) => {
  try {
    const snap = await getDoc(doc(db, 'users', uid));
    if (snap.exists() && snap.data().notificationPrefs) {
      return { ...DEFAULT_PREFS, ...snap.data().notificationPrefs };
    }
  } catch { /* fall through */ }
  return DEFAULT_PREFS;
};

export const saveNotificationPrefs = async (uid, prefs) => {
  await updateDoc(doc(db, 'users', uid), { notificationPrefs: prefs });
};

/**
 * Check if a notification should be sent.
 * @param {object} prefs - user's notification preferences
 * @param {string} category - 'bookingConfirmations' | 'paymentReminders' | 'doorAccess' | 'marketing'
 * @param {string} channel - 'email' | 'sms'
 * @returns {boolean}
 */
export const shouldNotify = (prefs, category, channel) => {
  if (!prefs || !prefs[category]) return DEFAULT_PREFS[category]?.[channel] ?? true;
  return prefs[category][channel] ?? false;
};
